import React from "react";
import Loader from "../components/loader";

const withLazyLoad = (
  importFunc: () => Promise<{ default: React.ComponentType<any> }>
) => {
  const LazyComponent = React.lazy(importFunc);

  return (props: Record<string, any>) => (
    <React.Suspense
      fallback={
        <div className="flex-grow h-screen flex items-center justify-center">
          <Loader />
        </div>
      }
    >
      <LazyComponent {...props} />
    </React.Suspense>
  );
};

export default withLazyLoad;
